import { useMutation } from '@apollo/client';
import {
  removePaymentMethodMutation,
  CurrentUser_paymentMethod,
  currentUserQuery
} from '../../core-types';
import { LoadableButton } from '../../components';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { REMOVE_PAYMENT_METHOD_MUTATION } from './graphql';
import { GraphQLErrors } from '../../components/GraphQLErrors';
import { CURRENT_USER_QUERY } from '../../lib/core/useCurrentUser';

const messages = defineMessages({
  confirmRemove: {
    id: 'paymentCard.confirmRemove',
    defaultMessage: 'Remove {brand} ending with {last4}?'
  }
});

export function RemovePaymentMethod({
  paymentMethod
}: {
  paymentMethod: CurrentUser_paymentMethod;
}) {
  const intl = useIntl();

  const [removePaymentMethod, { error, loading }] = useMutation<
    removePaymentMethodMutation
  >(REMOVE_PAYMENT_METHOD_MUTATION, {
    update: (cache, { data }) => {
      if (!data) {
        return;
      }
      const currentUserResult = cache.readQuery<currentUserQuery>({
        query: CURRENT_USER_QUERY
      });
      if (!currentUserResult?.currentUser) {
        return;
      }
      cache.writeQuery<currentUserQuery>({
        query: CURRENT_USER_QUERY,
        data: {
          ...currentUserResult,
          currentUser: {
            ...currentUserResult.currentUser,
            paymentMethod: null
          }
        }
      });
    }
  });

  return (
    <>
      {error && <GraphQLErrors error={error} />}
      {paymentMethod.__typename === 'Card' && (
        <LoadableButton
          variant="link"
          loading={loading}
          disabled={!paymentMethod.removable}
          responseState={error ? 'error' : 'success'}
          onClick={() => {
            if (
              confirm(
                intl.formatMessage(messages.confirmRemove, {
                  brand: paymentMethod.displayBrand,
                  last4: paymentMethod.last4
                })
              )
            ) {
              removePaymentMethod({
                variables: { paymentMethodId: paymentMethod.id }
              });
            }
          }}
        >
          <FormattedMessage
            id="paymentCard.remove"
            defaultMessage="Remove card"
          />
        </LoadableButton>
      )}
    </>
  );
}
